export const PointOfView = {
  Front: 'front',
  Left: 'left',
  Back: 'back',
  Right: 'right',
  Top: 'top',
};

export const SelectedViewer = {
  ThreeSixty: 'ThreeSixtyViewer',
  ThreeD: 'ModelViewer',
  TwoD: 'Lifestyle',
};

export const ObjectType = {
  Image: 'image',
  ModelGlb: 'modelGlb',
  ModelGlbU: 'modelGlbU',
  ModelUsd: 'modelUsd',
  ModelHdr: 'modelHdr',
  EnvironmentHdr: 'environmentHdr',
};

export const productImageTemplate = {
  image: null,
  thumbnail: null,
};

export const cameraTransform = {
  location: null,
  rotation: null,
};

export const mobileWidthThreshold = 540;
export const buttonHeightSpace = 180;
export const viewerBtnShrinkRatio = 0.8;
export const additionalButtonsMaxSize = 200;
export const timeBeforeShowingSpinIcon = 2500;
